/* Keeps at most one FAQ accordion open inside the Product FAQ section.
   Listens for <details> toggle events in the capture phase (toggle does not
   bubble) and closes any other open item, reusing icebox-accordion's animated
   close() when available so open and close both stay smooth.

   Because toggle events dispatch asynchronously, a burst of opens in one task
   would otherwise close everything: each queued toggle would close all other
   items, including the final one. Summary clicks are tracked in the capture
   phase so only the most recently requested item enforces the closures. */
if (!customElements.get('product-faq-accordions')) {
  customElements.define(
    'product-faq-accordions',
    class ProductFaqAccordions extends HTMLElement {
      connectedCallback() {
        if (!this.listenersBound) {
          this.onToggle = this.onToggle.bind(this);
          this.onSummaryClick = this.onSummaryClick.bind(this);
          this.addEventListener('toggle', this.onToggle, true);
          this.addEventListener('click', this.onSummaryClick, true);
          this.listenersBound = true;
        }
      }

      disconnectedCallback() {
        if (this.listenersBound) {
          this.removeEventListener('toggle', this.onToggle, true);
          this.removeEventListener('click', this.onSummaryClick, true);
          this.listenersBound = false;
        }
      }

      onSummaryClick(event) {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;
        this.lastRequested = summary.closest('details');
      }

      onToggle(event) {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        if (this.lastRequested && this.lastRequested !== opened) return;

        this.querySelectorAll('details[open]').forEach((other) => {
          if (other === opened) return;

          const accordion = other.closest('icebox-accordion');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (
            accordion &&
            typeof accordion.close === 'function' &&
            accordion.classList.contains('is-enhanced') &&
            !reduceMotion
          ) {
            if (typeof accordion.clearTransitionListeners === 'function') {
              accordion.clearTransitionListeners();
            }
            accordion.close();
          } else {
            other.removeAttribute('open');
          }
        });
      }
    }
  );
}
